let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
    
    // Handle direct input changes
    this.counterEl.addEventListener("input", this.onInput.bind(this));
    this.counterEl.addEventListener("change", this.onChange.bind(this));
    
    // Sync with cart immediately
    this.syncWithCart();
    
    // Multiple listeners for real-time cart updates
    const EVENTS = window.PUB_SUB_EVENTS || { cartUpdate: "cart-update" };
    
    // 1. Standard PUB_SUB_EVENTS
    if (window.subscribe && EVENTS) {
      this.cartUpdateUnsubscriber = window.subscribe(EVENTS.cartUpdate, (event) => {
        setTimeout(() => this.syncWithCart(), 50);
        
        // Reset quantity to 1 after successful cart addition
        if (event.source === "product-form" && !event.error) {
          setTimeout(() => {
            this.counterEl.value = 1;
            this.counterEl.dispatchEvent(new Event('change', { bubbles: true }));
          }, 100);
        }
      });
    }
    
    // 2. Custom cart quantity change event
    this.customEventListener = () => {
      setTimeout(() => this.syncWithCart(), 50);
    };
    document.addEventListener('cart-quantity-changed', this.customEventListener);
    
    // 3. Cart drawer refresh event
    this.cartRefreshListener = () => {
      setTimeout(() => this.syncWithCart(), 100);
    };
    document.addEventListener('cart-drawer:refresh', this.cartRefreshListener);
  }

  disconnectedCallback() {
    // Clean up all subscriptions
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.customEventListener) {
      document.removeEventListener('cart-quantity-changed', this.customEventListener);
    }
    if (this.cartRefreshListener) {
      document.removeEventListener('cart-drawer:refresh', this.cartRefreshListener);
    }
  }

  syncWithCart() {
    if (!window.CartSync) return;
    
    const form = this.closest('form');
    if (form) {
      window.CartSync.syncProductForm(form);
    }
  }

  getMaxAllowedQuantity() {
    if (!window.CartSync) return 5;
    
    const form = this.closest('form');
    if (!form) return 5;
    
    const variantId = window.CartSync.getCurrentVariantId(form);
    if (!variantId) return 5;
    
    const cartQuantity = window.CartSync.getCartQuantity(variantId);
    const remaining = Math.max(0, window.CartSync.MAX_QUANTITY - cartQuantity);
    
    // If cart already has max quantity, allow 1 in input but disable functionality
    return remaining === 0 ? 1 : remaining;
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value) || 0;
    const maxAllowed = this.getMaxAllowedQuantity();
    
    if (currentValue >= maxAllowed || maxAllowed === 0) {
      if (window.CartSync) {
        window.CartSync.showModal();
      }
      return;
    }
    
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  onInput() {
    const value = parseInt(this.counterEl.value) || 1;
    const maxAllowed = this.getMaxAllowedQuantity();
    
    if (value > maxAllowed) {
      this.counterEl.value = maxAllowed;
      if (window.CartSync) {
        window.CartSync.showModal();
      }
    }
  }

  onChange() {
    const value = parseInt(this.counterEl.value) || 1;
    const maxAllowed = this.getMaxAllowedQuantity();
    
    if (value > maxAllowed) {
      this.counterEl.value = maxAllowed;
      this.counterEl.dispatchEvent(this.changeEvent);
      if (window.CartSync) {
        window.CartSync.showModal();
      }
    }
  }

  updateValue(value) {
    const maxAllowed = this.getMaxAllowedQuantity();
    
    if (value > maxAllowed) {
      value = maxAllowed;
      if (window.CartSync) {
        window.CartSync.showModal();
      }
    }
    
    this.counterEl.value = value;
    this.counterEl.dispatchEvent(this.changeEvent);
  }

  showQuantityLimitModal() {
    if (window.CartSync) {
      window.CartSync.showModal();
    }
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// Quantity Limit Modal Functionality
(function() {
  let modalInitialized = false;
  
  function initModal() {
    if (modalInitialized) return;
    
    const overlay = document.getElementById('qtyLimitOverlay');
    const modal = document.getElementById('qtyLimitModal');
    const closeBtn = document.getElementById('qtyModalClose');
    
    if (!overlay || !modal || !closeBtn) return;
    
    let preventOverlayClose = 0;
    
    function closeModal() {
      overlay.style.display = 'none';
      overlay.style.pointerEvents = 'none';
      modal.style.display = 'none';
      overlay.setAttribute('aria-hidden', 'true');
    }
    
    // Close on overlay click
    overlay.addEventListener('click', (e) => {
      if (Date.now() < preventOverlayClose) return;
      closeModal();
    });
    
    // Close on button click
    closeBtn.addEventListener('click', closeModal);
    
    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'block') {
        closeModal();
      }
    });
    
    modalInitialized = true;
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModal);
  } else {
    initModal();
  }
})();

// Smart Cart Sync System - Event Driven with Fallback
window.CartSync = (function() {
  const MAX_QUANTITY = 5;
  let cartCache = null;
  let lastFetchTime = 0;
  let isInitialized = false;
  
  // Ensure PUB_SUB_EVENTS are available
  const EVENTS = window.PUB_SUB_EVENTS || {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update"
  };
  
  // Get current quantity of a variant in cart
  function getCartQuantity(variantId) {
    if (!cartCache || !cartCache.items) return 0;
    
    const item = cartCache.items.find(item => item.id == variantId);
    return item ? item.quantity : 0;
  }
  
  // Smart fetch - only when needed
  function fetchCartData(force = false) {
    const now = Date.now();
    const timeSinceLastFetch = now - lastFetchTime;
    
    // Skip if recently fetched (unless forced)
    if (!force && timeSinceLastFetch < 5000 && cartCache) {
      return Promise.resolve(cartCache);
    }
    
    lastFetchTime = now;
    
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        const newCache = {
          items: cartData.items.map(item => ({
            id: item.variant_id,
            product_id: item.product_id,
            quantity: item.quantity,
            key: item.key
          })),
          item_count: cartData.item_count
        };
        
        // Only sync if data actually changed
        const hasChanged = !cartCache || JSON.stringify(cartCache) !== JSON.stringify(newCache);
        cartCache = newCache;
        window.cartData = cartCache;
        
        if (hasChanged) {
          syncAllProductForms();
        }
        
        return cartCache;
      })
      .catch(error => {
        return cartCache || { items: [], item_count: 0 };
      });
  }
  
  // Update cart data after cart operations (with immediate sync)
  function updateCartData(newCartData) {
    if (newCartData && newCartData.items) {
      const oldCache = cartCache;
      cartCache = {
        items: newCartData.items.map(item => ({
          id: item.variant_id || item.id,
          product_id: item.product_id,
          quantity: item.quantity,
          key: item.key
        })),
        item_count: newCartData.item_count
      };
      
      window.cartData = cartCache;
      lastFetchTime = Date.now();
      
      // Check if quantities actually changed
      const hasQuantityChanges = !oldCache || 
        JSON.stringify(oldCache.items) !== JSON.stringify(cartCache.items);
      
      if (hasQuantityChanges) {
        // Immediate sync for quantity changes
        syncAllProductForms();
        
        // Also trigger custom event for additional listeners
        document.dispatchEvent(new CustomEvent('cart-quantity-changed', {
          detail: { cartData: cartCache }
        }));
      }
    }
  }
  
  // Get current variant ID from form
  function getCurrentVariantId(form) {
    // Try multiple selectors for variant ID
    const selectors = [
      'select[name="id"]',
      'input[name="id"]',
      'input[type="hidden"][name="id"]',
      '[data-variant-id]'
    ];
    
    for (const selector of selectors) {
      const element = form.querySelector(selector);
      if (element) {
        const variantId = element.value || element.dataset.variantId;
        if (variantId && variantId !== '') {
          return variantId;
        }
      }
    }
    
    // Fallback: try to get from URL or other sources
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    if (variantFromUrl) return variantFromUrl;
    
    return null;
  }
  
  // Sync product form based on cart quantity (silent mode)
  function syncProductForm(form) {
    const variantId = getCurrentVariantId(form);
    if (!variantId) return;
    
    const cartQuantity = getCartQuantity(variantId);
    const quantityInput = form.querySelector('input[name="quantity"], .js-counter-quantity');
    const submitButton = form.querySelector('button[type="submit"], .product-form__submit, [name="add"]');
    const quantityCounter = form.querySelector('quantity-counter');
    
    if (cartQuantity >= MAX_QUANTITY) {
      // Product already has max quantity in cart - DISABLE EVERYTHING but keep quantity at 1
      if (quantityInput) {
        quantityInput.value = 1;
        quantityInput.setAttribute('max', '1');
        quantityInput.disabled = true;
        quantityInput.style.opacity = '0.5';
        quantityInput.style.pointerEvents = 'none';
      }
      
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.style.opacity = '0.5';
        submitButton.style.pointerEvents = 'none';
        
        // Update button text
        const buttonText = submitButton.querySelector('span:not(.loading-overlay__spinner)') || submitButton;
        const originalText = buttonText.dataset.originalText || buttonText.textContent;
        if (!buttonText.dataset.originalText) {
          buttonText.dataset.originalText = originalText;
        }
        buttonText.textContent = 'Maximum Quantity in Cart';
      }
      
      // Disable counter buttons
      if (quantityCounter) {
        const increaseBtn = quantityCounter.querySelector('.js-counter-increase');
        const decreaseBtn = quantityCounter.querySelector('.js-counter-decrease');
        
        [increaseBtn, decreaseBtn].forEach(btn => {
          if (btn) {
            btn.disabled = true;
            btn.style.opacity = '0.5';
            btn.style.pointerEvents = 'none';
            btn.setAttribute('aria-disabled', 'true');
          }
        });
      }
    } else {
      // Product can still be added - ENABLE EVERYTHING
      const remainingQuantity = MAX_QUANTITY - cartQuantity;
      
      if (quantityInput) {
        const currentValue = parseInt(quantityInput.value) || 1;
        quantityInput.value = Math.min(currentValue, remainingQuantity);
        quantityInput.setAttribute('max', remainingQuantity);
        quantityInput.disabled = false;
        quantityInput.style.opacity = '';
        quantityInput.style.pointerEvents = '';
      }
      
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
        submitButton.style.opacity = '';
        submitButton.style.pointerEvents = '';
        
        // Restore button text
        const buttonText = submitButton.querySelector('span:not(.loading-overlay__spinner)') || submitButton;
        const originalText = buttonText.dataset.originalText;
        if (originalText) {
          buttonText.textContent = originalText;
        } else if (window.variantStrings) {
          buttonText.textContent = window.variantStrings.addToCart || 'Add to Cart';
        }
      }
      
      // Enable counter buttons
      if (quantityCounter) {
        const increaseBtn = quantityCounter.querySelector('.js-counter-increase');
        const decreaseBtn = quantityCounter.querySelector('.js-counter-decrease');
        
        [increaseBtn, decreaseBtn].forEach(btn => {
          if (btn) {
            btn.disabled = false;
            btn.style.opacity = '';
            btn.style.pointerEvents = '';
            btn.removeAttribute('aria-disabled');
          }
        });
      }
    }
  }
  
  // Sync all product forms on page (silent)
  function syncAllProductForms() {
    const productForms = document.querySelectorAll('product-form form, form[action*="/cart/add"]');
    productForms.forEach(syncProductForm);
  }
  
  // Listen for variant changes (smart detection)
  function initVariantSync() {
    document.addEventListener('change', function(e) {
      const target = e.target;
      
      // If variant selector changed
      if (target.matches('select[name="id"], input[name="id"]')) {
        const form = target.closest('form');
        if (form) {
          // Immediate sync for variant changes
          setTimeout(() => syncProductForm(form), 50);
        }
      }
    });
  }
  
  // Show quantity limit modal
  function showModal() {
    const overlay = document.getElementById('qtyLimitOverlay');
    const modal = document.getElementById('qtyLimitModal');
    
    if (overlay && modal) {
      overlay.style.display = 'block';
      overlay.style.pointerEvents = 'auto';
      modal.style.display = 'block';
      overlay.setAttribute('aria-hidden', 'false');
    }
  }
  
  // Initialize cart sync (one-time setup)
  function init() {
    if (isInitialized) return;
    isInitialized = true;
    
    // Initial cart fetch and sync
    fetchCartData(true).then(() => {
      syncAllProductForms();
    });
    
    // Setup variant change listener
    initVariantSync();
    
    // Multiple event listeners for cart updates
    
    // 1. Standard PUB_SUB_EVENTS (if available)
    if (window.subscribe && EVENTS) {
      window.subscribe(EVENTS.cartUpdate, function(event) {
        // Immediate update of cart data from the event
        if (event.cartData) {
          updateCartData(event.cartData);
        } else {
          // Fallback: fetch fresh data if no cart data in event
          setTimeout(() => {
            fetchCartData(true);
          }, 100);
        }
      });
    }
    
    // 2. Custom cart quantity change event
    document.addEventListener('cart-quantity-changed', function(event) {
      if (event.detail && event.detail.cartData) {
        syncAllProductForms();
      }
    });
    
    // 3. Listen for cart drawer updates (fallback)
    document.addEventListener('cart-drawer:refresh', function() {
      setTimeout(() => fetchCartData(true), 200);
    });
    
    // 4. MutationObserver for cart icon changes (additional fallback)
    const cartIcon = document.querySelector('.cart-count-bubble, [data-cart-count]');
    if (cartIcon) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            setTimeout(() => fetchCartData(true), 100);
          }
        });
      });
      
      observer.observe(cartIcon, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-cart-count']
      });
    }
  }
  
  // Initialize when DOM is ready (single initialization)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Public API
  return {
    getCartQuantity: getCartQuantity,
    updateCartData: updateCartData,
    syncProductForm: syncProductForm,
    syncAllProductForms: syncAllProductForms,
    showModal: showModal,
    fetchCartData: fetchCartData,
    MAX_QUANTITY: MAX_QUANTITY,
    getCurrentVariantId: getCurrentVariantId
  };
})();

// Handle product form submissions (silent validation)
document.addEventListener('submit', function(e) {
  const form = e.target;
  
  // Check if it's a product form
  if (form.matches('form[action*="/cart/add"]') || form.closest('product-form')) {
    if (!window.CartSync) return;
    
    const variantId = window.CartSync.getCurrentVariantId(form);
    const quantityInput = form.querySelector('input[name="quantity"], .js-counter-quantity');
    
    if (variantId) {
      const cartQuantity = window.CartSync.getCartQuantity(variantId);
      const quantity = parseInt(quantityInput?.value) || 1;
      const totalQuantity = cartQuantity + quantity;
      
      if (cartQuantity >= window.CartSync.MAX_QUANTITY || totalQuantity > window.CartSync.MAX_QUANTITY) {
        e.preventDefault();
        
        // Set to 1 instead of 0
        if (quantityInput) {
          quantityInput.value = 1;
        }
        
        // Show modal
        window.CartSync.showModal();
        return false;
      }
    }
  }
});

// Smart sync on important page events only + DOM monitoring
let lastSyncTime = 0;
const SYNC_COOLDOWN = 3000; // 3 seconds cooldown

function smartSync() {
  const now = Date.now();
  if (now - lastSyncTime < SYNC_COOLDOWN) return;
  lastSyncTime = now;
  
  if (window.CartSync) {
    window.CartSync.fetchCartData(true);
  }
}

// Only sync on critical events
document.addEventListener('visibilitychange', function() {
  if (!document.hidden) {
    smartSync();
  }
});

window.addEventListener('focus', smartSync);

// Monitor cart count changes in DOM
function monitorCartCount() {
  const cartCountElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count');
  
  cartCountElements.forEach(element => {
    if (element.dataset.monitored) return; // Already monitoring
    element.dataset.monitored = 'true';
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || 
            (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-count')) {
          // Cart count changed, sync immediately
          if (window.CartSync) {
            setTimeout(() => window.CartSync.fetchCartData(true), 100);
          }
        }
      });
    });
    
    observer.observe(element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart-count']
    });
  });
}

// Start monitoring when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', monitorCartCount);
} else {
  monitorCartCount();
}

// Re-monitor after dynamic content loads
setTimeout(monitorCartCount, 1000);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Custom video controls
document.addEventListener('DOMContentLoaded', () => {
  const BUTTON_SELECTOR = '.wt-hero-video__sound-toggle';
  const BUTTON_TOGGLE_CLASS = 'wt-hero-video__sound-toggle--unmuted';

  document.querySelectorAll(BUTTON_SELECTOR).forEach(button => {
    button.addEventListener('click', () => {
      const parent = button.parentElement;
      if (!parent) return;

      let video = null;

      video = Array.from(parent.children).find(
          el => el.tagName === 'VIDEO'
      );

      if (!video) {
        const heroVideoContainer = Array.from(parent.children).find(
            el => el.classList && el.classList.contains('hero--video-background')
        );

        if (heroVideoContainer) {
          video = heroVideoContainer.querySelector('video');
        }
      }

      if(!video){
          const grandparent = parent.closest('video-controls');
          console.log(grandparent);
          video = Array.from(grandparent.children).find(
            el => el.tagName === 'VIDEO'
        );
      }

      if (!video) return;

      video.muted = !video.muted;
      button.classList.toggle(BUTTON_TOGGLE_CLASS, !video.muted);
    });
  });
});


